<h2 class="mt-5 text-center">
    Calcul en cours ...
    <mat-spinner diameter="50" color="second"></mat-spinner>
</h2>
